<form class="card-form" [formGroup]="form" (submit)="submit()">
  <mat-card>
    <mat-card-title i18n="title @@auth.validate.title">
      Create your account
    </mat-card-title>

    <mat-card-content>
      <p class="mat-typography light" i18n="text @@auth.validate.explanation">
        Use 10 to 20 characters, at least one lowercase letter, one uppercase letter and
        one digit.
      </p>

      <p>
        <tc-password-field formControlName="plainPassword" [autofocus]="true"></tc-password-field>
      </p>

      <p>
        <mat-checkbox color="primary" #terms>
          <span class="space-after" i18n="As in I agree to the terms and conditions @@auth.validate.terms">I agree to the</span>
          <a class="space-text" href="https://www.tradecloud1.com/en/terms-and-conditions" target="_blank" rel="noopener"  i18n="link @@auth.validate.link">terms of service</a>
        </mat-checkbox>
      </p>

      <p *ngIf="errorMessage">
        <mat-error>{{ errorMessage }}</mat-error>
      </p>
    </mat-card-content>

    <mat-card-actions>
      <button type="submit" mat-raised-button color="primary" [disabled]="!terms.checked || form.disabled" i18n="button @@auth.validate.submit">CONTINUE</button>
    </mat-card-actions>
  </mat-card>
</form>
